import factory from '../requestFactory';

export default (phone,type,tokenReCaptcha) => {

    let phoneFormatted  = phone.replace(/[-()\+]/g,'');
    return factory()
        .post('/sms', {
            phone:phoneFormatted,
            sms_code_type: process.env.VUE_APP_ENABLE_SMS == 'true' ? 'random' : 'static',
            type:type,
            token_recaptcha: tokenReCaptcha,
        });
}
